import boolean from './boolean'
import currency from './currency'
import customer from './customer'
import datetime from './datetime'
import fulfillment from "./fulfillment";
import orderStatus from './orderStatus'
import paymentStatus from './paymentStatus'
import productCategories from "./productCategories";
import product from './product'

export default {
    boolean, currency, customer, datetime, fulfillment, orderStatus, paymentStatus, productCategories, product
}